import createReducer from '../../../data/shared/createReducer';
import { SIGN_UP_SUCCESS, RESET_SIGN_UP } from '../constants/action_types';

const initialState = {
    submitted: false,
    success: false,
    user: null
};

// const signUpFailure = (state, action) => ({
//     ...state,
//     error: 'error'
// });

const signUpSuccess = (state, action) => ({
    ...state,
    submitted: true,
    success: true,
    user: action.data
});

const resetSignUp = (state, action) => ({
    ...initialState
});

const signUpReducer = createReducer(initialState, {
    [SIGN_UP_SUCCESS]: signUpSuccess,
    [RESET_SIGN_UP]: resetSignUp
});

export default signUpReducer;
